import Header from "./Component/Header";

export default function Payment() {
    return (
        <>
            <Header />

            <main id="content">
                <div className="w-full max-w-4xl mx-auto">
                    <div className="bg-card border border-card-line rounded-lg shadow-md">
                        <div className="py-3 px-5 border-b border-card-footer">
                            <nav
                                className="flex"
                                aria-label="Tabs"
                                role="tablist"
                                aria-orientation="horizontal"
                            >
                                <button
                                    type="button"
                                    className="inline-flex flex-col gap-y-px justify-center items-center w-full text-sm rounded-lg focus:outline-hidden text-primary font-medium"
                                    aria-selected="true"
                                >
                                    <span className="py-2 px-4 rounded-full">Payment Action</span>
                                </button>
                            </nav>
                        </div>

                        <div className="p-5 space-y-4">
                            <div className="rounded-lg border border-line-2 overflow-hidden bg-layer">
                                <iframe
                                    title="Payment Iframe"
                                    src="https://sakurupiah.id/sanbox-payout.php?reference_id=SBX1wTtK7cOCL-At1Pvej3FS-RnTfqy57S786"
                                    className="w-full h-[70vh]"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
}

